const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const SMSReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_SMS_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_SMS_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_SMS_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
        case "SET_SMS_RESET":
        return {
            ...state,
            isLoading: false,
            data: [],
            error: null,
        };
      default:
        return state;
    }
  };
  
  export default SMSReducer;